import dynamic from "next/dynamic";
const ElectionPage = dynamic(() => import("@/screens/FiveStateElection"));
const PageLayout = dynamic(() => import("@/screens/Layout/PageLayout"));

import { getDataByUrl } from "@/handlers/commonApi";
import { MasterConfigContext } from "@/context/MasterConfigContext";
import useIsMobile from "@/hooks/useIsMobile";

import { useContext } from "react";

export default function ElectionTab({
  categoryNewsListData = null,
  latestStoryData = null,
  latestVideoData = null,
  electionCategory = null,
  constituencyListData = null,
}) {
  const masterConfig = useContext(MasterConfigContext);
  const biharElectionKey = masterConfig["puducherry_election"];
  const resultYear = biharElectionKey?.resultPageMetaYear || "2026";
  const isMobileDevice = useIsMobile();
  const oldResult = {
    partyData: [
      {
        color: "#FF9933",
        partyName: "CONG+",
        partySeat: "8",
      },
      {
        color: "#19AAED",
        partyName: "BJP+",
        partySeat: "16",
      },
      {
        color: "#CC0000",
        partyName: "OTH",
        partySeat: "6",
      },
    ],
  };
  const oldDesc = `Puducherry Assembly Elections 2026: क्या रंगासामी फिर बचा पाएंगे अपनी कुर्सी या 'इंडिया' गठबंधन करेगा सत्ता पर कब्जा? केंद्र शासित प्रदेश पुडुचेरी की सभी 30 विधानसभा सीटों पर एक बार फिर चुनावी बिसात बिछ चुकी है. पुडुचेरी में 9 अप्रैल 2026 को एक ही चरण में मतदान होगा. साल 2021 के चुनावी नतीजों पर नजर डालें तो एन. रंगासामी के नेतृत्व वाले NDA ने 16 सीटें जीतकर बहुमत हासिल किया था. उस चुनाव में रंगासामी की पार्टी AINRC (ऑल इंडिया एनआर कांग्रेस) ने 10 और उसकी सहयोगी BJP ने 6 सीटों पर जीत दर्ज की थी. दूसरी ओर, UPA गठबंधन को केवल 8 सीटें मिली थीं, जिसमें DMK को 6 और कांग्रेस को मात्र 2 सीटों से संतोष करना पड़ा था. 6 सीटों पर निर्दलीय उम्मीदवारों ने बाजी मारी थी.
<br/> 
इस बार का चुनाव 'डबल इंजन' सरकार की साख का इम्तिहान है. मुख्यमंत्री एन. रंगासामी चौथी बार सत्ता संभालने के बाद अपनी लोक-लुभावन योजनाओं और विकास के नाम पर वोट मांग रहे हैं. वहीं, विपक्षी गठबंधन 'इंडिया' (जिसमें कांग्रेस और DMK मुख्य रूप से साथ हैं) सत्ता विरोधी लहर और राज्य के अधिकारों जैसे मुद्दों को लेकर मैदान में है. 4 मई को आने वाले नतीजे यह तय करेंगे कि पुडुचेरी की जनता रंगासामी के अनुभव पर भरोसा जताती है या फिर विपक्ष के बदलाव के नारे को स्वीकार करती है. `

  const newDesc = oldDesc
  // const newDesc = `Puducherry Assembly Elections Results 2026: इस बार के पुडुचेरी विधानसभा चुनाव में कौन मारेगा बाजी? NDA या महागठबंधन...किसको मिलेगा बहुमत? BJP के साथ मिलकर JDU कर पाएगा कमाल या RJD और कांग्रेस की जोड़ी में VIP और लेफ्ट पार्टी मिल पलट देंगी गेम? नीतीश की बनेगी सरकार या प्रशांत किशोर की भविष्यवाणी होगी सच?  सबसे सटीक और तेज नतीजों के लिए बने रहिए न्यूज Tak के साथ.`;

  let metaData = {
    title: `Puducherry Assembly Chunav  ${resultYear} Results: पुडुचेरी विधानसभा चुनाव रिजल्ट  ${resultYear} जानें सभी सीटों के नतीजे - NewsTak`,
    description: `Puducherry Assembly Election  ${resultYear} Results: पुडुचेरी विधानसभा चुनाव  ${resultYear} के सभी सीटों के ताज़ा नतीजे और जीत-हार के आंकड़े देखें। जानें किस पार्टी को कितनी सीटें मिलीं और कौन बना रहा है सरकार — लाइव अपडेट्स के साथ।`,
    keywords: `पुडुचेरी विधानसभा चुनाव ${resultYear} परिणाम, Puducherry Assembly Election ${resultYear} Results, Puducherry Chunav Result ${resultYear}, Puducherry Election Result Live, Puducherry Vidhan Sabha Result, Puducherry Election Seat Wise Result, पुडुचेरी सीटवार चुनाव नतीजे, Puducherry Election Winner List, पुडुचेरी चुनाव वोट गिनती, Puducherry Assembly Election Live Updates, किसे कितनी सीटें मिली पुडुचेरी चुनाव, Puducherry Election Final Result ${resultYear}`,
  };

  return (
    <section>
      <PageLayout
        latestStoryData={latestStoryData}
        latestVideoData={latestVideoData}
      >
        <ElectionPage
          categoryNewsListData={categoryNewsListData}
          // faqData={faqData}

          electionPath={`${electionCategory}/results`}
          isMobileDevice={isMobileDevice}

          electionPassedCategory={electionCategory} //'delhi-assembly'
          masterKey="puducherry_election"
          stateName={"Puducherry"} //"Delhi"
          stateHindi={"पुडुचेरी"}
          metaData={metaData}
          oldResult={oldResult}
          oldDesc={oldDesc}
          newDesc={newDesc}
          resultKey={"partiesDataBR"}
          constituencyListData={constituencyListData}
        />
      </PageLayout>
    </section>
  );
}
//staticpages?url=sample-faqs
export const getServerSideProps = async (ctx) => {
  const { logger } = await import("@/utils/logging/log-util");

  let url = ctx?.resolvedUrl;
  url = url.split("/results")[0];

  let electionCategory = url.split("/elections/")[1];

  if (!electionCategory) {
    return {
      notFound: true,
    };
  }

  try {
    const { getLatestStoryVideoFeed, splitLatestStoryVideoFeed } = await import("@/handlers/content");
    const { getRedisApiKey, fetchRedisWrapper } = await import(
      "@/handlers/redisKey"
    );
    const { setPageTTL } = await import("@/utils/setPageTTL");
    const { getUnixTimeDaysAgo } = await import("@/utils/dateTimeFormat");
    const unixtime = getUnixTimeDaysAgo(15);

    let categoryListRedisKey = getRedisApiKey({
      redisPrefix: "PREFIX_REDIS_ROS",
      params: {
        api: "getdatabyurl",
        url: url,
        page: 0,
        display: 12,
        type: "all",
      },
    });

    // faq key
    // let faqRedisKey = getRedisApiKey({
    //   masterConfigData: masterConfigData,
    //   redisPrefix: "PREFIX_REDIS_ROS",
    //   params: { api: "staticpages", url: "sample-faqs" },
    // });

    //* get redis api key for each api
    const latestStoryVideoRedisKey = getRedisApiKey({
      redisPrefix: "PREFIX_REDIS_ROS",
      params: {
        api: "latestcontentfeed",
        page: 0,
        display: 5,
        type: "story,video",
        unixtime,
      },
    });
    let electionConfigData = null;
    const electionConfig = await fetch(
      `${process.env.BASE_PATH + process.env.API_PREFIX
      }/masterconfig`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    ).then(async (res) => {
      return await res.json();
    });
    electionConfigData = electionConfig?.data?.puducherry_election;
    let constituencyListData = null;

    let constituencyUrl =
      electionConfigData?.constListYear == 2021
        ? electionConfigData?.allConstituency2021Api
        : electionConfigData?.allConstituency2026Api;
    // `https://akm-img-a-in.tosshub.com/sites/elections/2024/assembly/json/state-master/delhi-2020-all-consituency.json`;
    // `https://akm-img-a-in.tosshub.com/sites/elections/2024/assembly/json/state-master/jharkhand-state-master.json`;
    await fetch(constituencyUrl, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    }).then(async (data) => {
      const data1 = await data.json();
      // console.log("delhi-constitutency", data1);
      constituencyListData = data1 || []; //electionConfigData?.constListYear==2020 ?  data1 : data1?.data;
    }).catch((error) => {
      logger.error("Error fetching constituency list data:", error);
      constituencyListData = [];
    });
    let [
      categoryNewsListData,
      { latestStoryData, latestVideoData },
      // , faqData
    ] = await Promise.all([
      fetchRedisWrapper(categoryListRedisKey, () =>
        getDataByUrl({
          url: url,
          page: 0,
          display: 12,
          type: "all",
        })
      ),
      fetchRedisWrapper(latestStoryVideoRedisKey, () =>
        getLatestStoryVideoFeed({
          page: 0,
          display: 5,
          unixtime,
        })
      ).then(splitLatestStoryVideoFeed),
      // fetchRedisWrapper(faqRedisKey, () =>
      //   getFaqBySlug({
      //     url: "sample-faqs",
      //   })
      // ),
    ]);

    // let headerCache = categoryNewsListData?.cache;
    setPageTTL(ctx, 120);

    return {
      props: {
        categoryNewsListData,
        latestStoryData,
        latestVideoData,
        electionCategory,
        constituencyListData,
        // faqData,
      },
    };
  } catch (error) {
    logger.error(error);
    return {
      notFound: true,
    };
  }
};
